'use client';

const APP_NAME = 'frontends-organization-team-plan';

export default function customImageLoader({
    src,
    width,
    quality,
}: {
    src: string;
    width: number;
    quality?: number;
}) {
    if (!src.includes('https://')) {
        return `/${APP_NAME}/${src}?w=${width}&q=${quality || 75}`;
    }
    return `${src}?w=${width}&q=${quality || 75}`;
}
